import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11, _templateObject12;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { PureComponent, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { clearModalState, updateModalOpenState, openModal } from '../../redux/modal';
import { performApiRequest, getResultData } from '../../redux/apiData';
import withMatch from '@/hocs/withMatch';
// Services
import withApiData from '../../services/withApiData';
import formatPrice from '../../services/formatPrice';
import { getOrderStatusColor } from '../../constants/orderStatusses';
import { getOptionUpdateDate } from './utils/optionDetails';

// Components
import ButtonPrimary from '../shared/buttons/ButtonPrimary';
import OrderStatusMessage from './OrderStatusMessage';
import Alert from '../shared/icons/Alert';

// Styles
import { colorPalette, colorPaletteRGB, shadows, textStyles } from '../../styles/styleGuide';
import { fromBreakpoint } from '../../styles/breakpoints';
var connectApiData = withApiData({
  orderDetails: 'getOptionOrder'
}, function (ownProps) {
  return {
    orderDetails: {
      projectSlug: ownProps.projectSlug,
      orderId: ownProps.orderId
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    wishList: getResultData(state.apiData, 'getWishList', {
      projectSlug: ownProps.projectSlug,
      wishListId: String(ownProps.match.params.wishListId)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    getWishList: function getWishList() {
      dispatch(performApiRequest('getWishList', {
        projectSlug: ownProps.projectSlug,
        wishListId: String(ownProps.match.params.wishListId)
      }));
    },
    openConfirmModal: function openConfirmModal(orderId) {
      dispatch(openModal(colorPalette.blue, {
        type: 'orderConfirm',
        componentProps: {
          projectSlug: String(ownProps.projectSlug),
          orderId: orderId
        }
      }));
    },
    closeModal: function closeModal() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var ProductOptionFinalConfirmationModal = /*#__PURE__*/function (_PureComponent) {
  function ProductOptionFinalConfirmationModal() {
    var _this;
    _classCallCheck(this, ProductOptionFinalConfirmationModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ProductOptionFinalConfirmationModal, [].concat(args));
    _defineProperty(_this, "handleClose", function () {
      var closeModal = _this.props.closeModal;
      closeModal();
      window.location.reload();
    });
    _defineProperty(_this, "getOpenOrders", function () {
      var _this$props = _this.props,
        wishList = _this$props.wishList,
        orderId = _this$props.orderId,
        categories = _this$props.categories;
      var openOrders = [];
      if (wishList) {
        wishList.categories && wishList.categories.map(function (_ref) {
          var subcategories = _ref.subcategories;
          return (subcategories || []).map(function (_ref2) {
            var options = _ref2.options;
            return (options.length > 0 && options || []).map(function (option) {
              return (option.orders.length > 0 && option.orders || []).map(function (order) {
                if (order.place === 'processed' && order.id !== orderId) {
                  return openOrders.push({
                    id: order.id,
                    title: option.title,
                    price: option.price,
                    optionCode: option.optionCode,
                    place: order.place,
                    placeDescription: order.placeDescription,
                    lastUpdate: order.lastUpdate
                  });
                } else {
                  return null;
                }
              });
            });
          });
        });
      }
      if (categories) {
        categories.map(function (category) {
          return category.orders.map(function (order) {
            if (order.place === 'processed' && order.id !== orderId) {
              return openOrders.push({
                id: order.id,
                title: order.option.title,
                price: order.option.price,
                optionCode: order.option.optionCode,
                place: order.place,
                placeDescription: order.placeDescription,
                lastUpdate: order.lastUpdate
              });
            } else {
              return null;
            }
          });
        });
      }
      return openOrders;
    });
    return _this;
  }
  _inherits(ProductOptionFinalConfirmationModal, _PureComponent);
  return _createClass(ProductOptionFinalConfirmationModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.match.params.wishListId) {
        this.props.getWishList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        confirmed = _this$props2.confirmed,
        orderDetails = _this$props2.orderDetails,
        success = _this$props2.success,
        openConfirmModal = _this$props2.openConfirmModal;
      var data = orderDetails.data;
      var openOrders = this.getOpenOrders();
      return data && success ? __jsx(Container, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Container"
      }, __jsx(Content, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Content"
      }, __jsx(Title, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Title"
      }, confirmed ? "De bevestiging is ondertekend" : "Reactie is verzonden"), __jsx(Intro, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Intro"
      }, confirmed ? "Bedankt! We hebben de door jou ondertekende bevestiging ontvangen voor de optie:" : "Je hebt aangegeven niet akkoord te zijn met de manier waarop deze kopersoptie ter bevestiging aan je is voorgelegd. We nemen je reactie en de toelichting die je hebt gegeven in behandeling en zullen contact met je opnemen om deze te bespreken. In de tussentijd wijzigt de status van deze order naar \u2018Reactie in behandeling\u2019. Je vindt deze order samen met andere orders en optie-aanvragen op de pagina mijn woning, inclusief de actuele orderstatus. Heb je vragen over deze of andere orders? Neem contact op met de woonadviseur."), confirmed && __jsx(Fragment, null, __jsx(OptionTitle, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionTitle"
      }, data.option.title), __jsx(OptionPrice, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionPrice"
      }, formatPrice(data.option.price, {
        showDecimal: true,
        showEuroSign: true
      })), data.option.optionCode && __jsx(OptionCode, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionCode"
      }, "Optiecode: ", data.option.optionCode), __jsx(Text, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Text"
      }, "We nemen deze bevestiging in behandeling. Wanneer je order definitief is goedgekeurd, wijzigt de status van de order naar \u2018Definitief, meer-/minderwerk\u2019. Je vindt deze order samen met andere orders en optie-aanvragen op de pagina mijn woning, inclusief de actuele orderstatus. Heb je vragen over deze of andere orders? Neem contact op met de woonadviseur.")), __jsx(ButtonContainer, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonContainer"
      }, __jsx(ButtonPrimary, {
        type: "button",
        onClick: this.handleClose,
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonPrimary"
      }, "Terug naar mijn woning"))), openOrders.length > 0 && __jsx(OtherOptions, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_OtherOptions"
      }, __jsx(Content, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Content"
      }, __jsx(NotificationTitle, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_NotificationTitle"
      }, __jsx(Alert, {
        color: colorPalette.orange,
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Alert"
      }), __jsx("span", {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_span"
      }, "In afwachting van bevestiging (", openOrders.length, ")")), openOrders.map(function (order, orderIndex) {
        var handleOrderClick = function handleOrderClick() {
          return openConfirmModal(order.id);
        };
        return __jsx(OtherOption, {
          key: orderIndex,
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OtherOption"
        }, __jsx(OptionTitle, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionTitle"
        }, order.title), __jsx(OptionPrice, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionPrice"
        }, formatPrice(order.price, {
          showDecimal: true,
          showEuroSign: true
        })), order.optionCode && __jsx(OptionCode, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OptionCode"
        }, "Optiecode: ", order.optionCode), order.place && __jsx(OrderStatusMessage, {
          color: getOrderStatusColor(order.place),
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_OrderStatusMessage"
        }, order.placeDescription, " (", getOptionUpdateDate(order.lastUpdate), ")"), order.place === 'processed' && __jsx(ButtonOrderContainer, {
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonOrderContainer"
        }, __jsx(ButtonPrimary, {
          type: "button",
          size: "small",
          label: "Controleren en bevestigen",
          clickHandler: handleOrderClick,
          "data-id": "homestudio_ProductOptionFinalConfirmationModal_ButtonPrimary"
        })));
      })))) : __jsx(Container, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Container"
      }, __jsx(Content, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Content"
      }, __jsx(Title, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Title"
      }, "Er is iets misgegaan"), __jsx(Intro, {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_Intro"
      }, "Het is niet gelukt je reactie te verzenden. ", __jsx("br", {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_br"
      }), __jsx("br", {
        "data-id": "homestudio_ProductOptionFinalConfirmationModal_br_27"
      }), "Probeer het nogmaals en neem anders contact op met de woonadviseur.")));
    }
  }]);
}(PureComponent);
export default withMatch(connectApiData(connect(mapStateToProps, mapDispatchToProps)(ProductOptionFinalConfirmationModal)));
var NotificationTitle = styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  display: flex;\n  align-items: center;\n  color: ", ";\n  margin: 0 0 20rem;\n\n  > span {\n    margin-left: 12px;\n  }\n"])), textStyles.title, colorPalette.orange);
var OtherOption = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 40rem;\n"])));
var ButtonOrderContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-top: 20rem;\n"])));
var OtherOptions = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  background-color: rgba(", ", 0.15);\n"])), colorPaletteRGB.loadingOrange);
var Container = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  background-color: ", ";\n  ", ";\n\n  ", ";\n"])), colorPalette.white, shadows.boxPrimary, textStyles.bodyText);
var Content = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 780rem;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 48rem 20rem;\n  box-sizing: border-box;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    padding: 100rem 20rem;\n  "]))));
var OptionTitle = styled.h4(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 12rem;\n"])), textStyles.title, colorPalette.headerGrey);
var OptionCode = styled.span(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-size: 14rem;\n  display: block;\n  margin: 0 0 12rem;\n"])), textStyles.caption, colorPalette.beige);
var OptionPrice = styled.p(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  font-weight: normal;\n  margin: 0 0 10rem;\n"])), textStyles.subTitle, colorPalette.headerGrey);
var Title = styled.h2(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), textStyles.pageTitle, colorPalette.headerGrey);
var Intro = styled.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", ";\n  color: ", ";\n  margin: 0 0 32rem;\n"])), textStyles.introText, colorPalette.headerGrey);
var Text = styled.p(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n  margin-top: 24rem;\n  margin-bottom: 30rem;\n"])), textStyles.bodyText);
var ButtonContainer = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n"])));